module.exports = __webpack_public_path__ + "img/62.34c77264.jpg";